'use client';

// Engineer gate + lazy mount for the stage-simulator executor. Rendered
// unconditionally by the market detail layout; returns `null` for end users so
// the `StageOverrideApplier` chunk (which pulls in
// `@morfi/backend-sdk-v2/devtool`) never downloads outside engineer sessions.
//
// Mirrors the `<DevToolkit />` gate (NODE_ENV or `@morfi.markets` email) +
// dynamic-import pattern.
import { c as _c } from "react/compiler-runtime";
import type { GetMarketRow } from '@morfi/backend-sdk-v2/client';
import { useEngineerIdentity } from '@morfi/backend-sdk-v2/client';
import dynamic from 'next/dynamic';
import type { ComponentType, JSX } from 'react';
const IS_DEV: boolean = process.env.NODE_ENV !== 'production';
const INTERNAL_EMAIL_DOMAIN = '@morfi.markets';
function isInternalEmail(email: string | null | undefined): boolean {
  return typeof email === 'string' && email.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN);
}
const StageOverrideApplier: ComponentType<{
  pubkey: string;
  market: GetMarketRow | undefined;
}> = dynamic(() => import('@/components/dev-toolkit/stage-override-applier'), {
  ssr: false,
  loading: (): null => null
});
const ResolvedStateApplier: ComponentType<{
  pubkey: string;
  market: GetMarketRow | undefined;
}> = dynamic(() => import('@/components/dev-toolkit/resolved-state-applier'), {
  ssr: false,
  loading: (): null => null
});
export function StageOverrideMount(t0) {
  const $ = _c(3);
  const {
    pubkey,
    market
  } = t0;
  const {
    user
  } = useEngineerIdentity();
  if (!IS_DEV && !isInternalEmail(user?.email)) {
    return null;
  }
  let t1;
  if ($[0] !== market || $[1] !== pubkey) {
    t1 = <><StageOverrideApplier pubkey={pubkey} market={market} /><ResolvedStateApplier pubkey={pubkey} market={market} /></>;
    $[0] = market;
    $[1] = pubkey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}